import React from 'react';
import PropTypes from 'prop-types';
import UiKitButton from 'components/UiKit/Button';

const FooterButtons = ({ handleSubmit, handleCancel, isDisabled, divider }) => (
  <div className="h-16 flex flex-row justify-end border-t-2 px-6 items-center">
    <UiKitButton size="lg" onClick={handleCancel} ghost>
      Cancel
    </UiKitButton>
    {divider('w-4')}
    <UiKitButton
      variant="primary"
      size="lg"
      onClick={handleSubmit}
      disabled={isDisabled}
    >
      Save Location
    </UiKitButton>
  </div>
);

FooterButtons.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  divider: PropTypes.func.isRequired
};

export default FooterButtons;
